__turbopack_context__.v({
  "container": "Container-module-scss-module__1s_XlW__container",
});
